module.exports = __webpack_public_path__ + "img/delete.6f5ce998.svg";